import styled from 'styled-components'
import { Form } from 'antd'

export const StyledFormItemWrapper = styled(Form.Item)`
  position: relative;
  height: ${props => props.isdefaultheight ? '77px' : 'unset'};
  margin-bottom: 12px;
  .ant-form-item-label {
    display: none;
  }
  .label {
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 0px;
    transition: 0.2s ease all;
    color: var(--grey);
  }
  .label-float {
    top: -24px;
    font-size: 16px;
  }

  @media only screen and (max-width: 768px) {
    .label-float {
      top: ${props => props.labellength > 16 ? '-50px' : '-24px'}
    }
  }
`
